import { useEffect, useState } from 'react';

type Theme = 'dark' | 'light' | 'system';

/**
 * Theme hook for dark/light mode
 * 
 * Persists theme preference in localStorage
 * Automatically applies theme to document root
 */
export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(() => {
    const stored = localStorage.getItem('vanguard-theme') as Theme;
    return stored || 'system';
  });

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');

    if (theme === 'system') {
      const systemTheme = window.matchMedia('(prefers-color-scheme: dark)')
        .matches
        ? 'dark'
        : 'light';
      root.classList.add(systemTheme);
      return;
    }

    root.classList.add(theme);
  }, [theme]);

  const setTheme = (newTheme: Theme) => {
    localStorage.setItem('vanguard-theme', newTheme);
    setThemeState(newTheme);
  };

  return {
    theme,
    setTheme,
  };
}
